<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 15:57:18
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-15 22:23:05
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/chart-pie.vue
 * @Description: 玫瑰图
-->
<template>
  <div id="chart-pie" v-loading="loading.ckj"></div>
</template>

<script>
import { Chart } from '@antv/g2'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      chart: null
    }
  },
  computed: {
    ...mapState('company-profile', ['ckj', 'loading'])
  },
  watch: {
    'loading.ckj' (newValue) {
      if (this.chart) {
        this.chart.changeData(newValue)
      } else {
        this.initChart()
      }
    }
  },
  methods: {
    initChart () {
      this.chart = new Chart({
        container: 'chart-pie',
        autoFit: true
      })
      this.chart.data(this.ckj)
      this.chart.coordinate('theta', {
        radius: 0.7,
        innerRadius: 0.55
      })
      this.chart.legend(false)
      this.chart.axis(false)
      this.chart.tooltip(false)
      this.chart
        .interval()
        .adjust('stack')
        .position('value')
        .label('value', {
          // layout: { type: 'pie-spider' },
          offset: 25,
          labelLine: {
            style: {
              lineWidth: 2
            }
          },
          style: {
            fill: '#ffffff'
          },
          content: (data) => {
            return `${data.name} ${data.value}`
          }
        })
        .color('name', ['l(0) 0:#08EAB2 1:#058D6B', 'l(0) 0:#36C7F8 1:#0D88B1', 'l(0) 0:#4AADF8 1:#248FDF', 'l(0) 0:#0270F3 1:#0266DB', 'l(0) 0:#19408C 1:#123878', 'l(0) 0:#E57D66 1:#DF755E'])
        // .color('name', ['#07E9B1', '#35C6F6', '#49ABF7', '#0270F3', '#183F8A', '#E57D65'])
      this.chart.render()
    }
  }
}
</script>
